import {CUSTOM_METRIC_PREFIX} from '../analytics.constants';
import {MetricValue} from '../analytics.types';
import _map from 'lodash/map';
import _flattenDeep from 'lodash/flattenDeep';

export default function getAllSupportedMetrics(
  supportedMetrics: MetricValue[],
  customMetricsOptions: Partial<Record<MetricValue, string[]>>,
) {
  const allSupportedMetrics = _map(supportedMetrics, (value) => {
    return [value, customMetricsOptions?.[`${CUSTOM_METRIC_PREFIX}${value}` as MetricValue] ?? []];
  });

  return _flattenDeep(allSupportedMetrics) as MetricValue[];
}
